@if (controlInfo) {
    <eff-expansion-panel
        [contentTemplate]="content"
        [panelOpenState]="panelOpenState"
        [title]="
            controlInfo.SnapshotDate
                ? ('effControlInfoBox.panelTitleAtDate'
                  | t: { date: (controlInfo.SnapshotDate | dateFormat) })
                : ('effControlInfoBox.panelTitle' | t)
        "
        class="eff-details-panel"
        data-uiid="new-eff-upload-source-document-control-description-info-box"
    >
        <ng-template #content>
            <div class="rows-container">
                <div class="d-flex flex-row justify-content-between">
                    <eff-button
                        class="link-button"
                        icon="north_east_outlined"
                        size="medium-size"
                        iconPosition="right"
                        iconSize="small-size"
                        [text]="'effControlInfoBox.openControl' | t"
                        data-uiid="new-eff-control-info-box-open-control-button"
                        (click)="openControl()"
                    ></eff-button>
                    <eff-button
                        class="link-button"
                        icon="north_east_outlined"
                        size="medium-size"
                        iconPosition="right"
                        iconSize="small-size"
                        [text]="'effControlInfoBox.testplanOverview' | t"
                        data-uiid="new-eff-control-info-box-testplan-overview-button"
                        (click)="openEffOverview()"
                    ></eff-button>
                </div>
                <div class="row-container">
                    <div class="bold-text row-label">{{ 'effControlInfoBox.id' | t }}</div>
                    <div class="regular-text">{{ controlInfo.ControlIdentifier }}</div>
                </div>

                <div class="row-container">
                    <div class="bold-text row-label">{{ 'effControlInfoBox.controlName' | t }}</div>
                    <div class="regular-text">{{ controlInfo.ControlName }}</div>
                </div>

                <div class="row-container">
                    <div class="bold-text row-label">{{ 'effControlInfoBox.controlFrequency' | t }}</div>
                    <div class="regular-text">{{ controlInfo.ControlFrequency }}</div>
                </div>

                <div class="row-container">
                    <div class="bold-text row-label">{{ 'effControlInfoBox.executionMethod' | t }}</div>
                    <div class="regular-text">{{ controlInfo.ControlExecutionMethod }}</div>
                </div>

                <div class="bold-text row-label">{{ 'effControlInfoBox.description' | t }}</div>
                <div
                    class="regular-text multiple-whitespaces"
                    [innerHTML]="controlInfo.ControlDescription"
                ></div>
            </div>
        </ng-template>
    </eff-expansion-panel>
}
